export default __webpack_public_path__ + "static/media/demo-12.ab72d00b.png";